export default __webpack_public_path__ + "locales/fi/Webhooks.json?hash=6c6c557dc3e55fcd546b5a7b55154e90";